// var templateUrl = site.theme_url; // this comes from functions.php

// Customize BootStrap - import only what we need
// import Alert from 'bootstrap/js/dist/alert';
// import Button from 'bootstrap/js/dist/button';
// import Carousel from 'bootstrap/js/dist/carousel';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
// import Offcanvas from 'bootstrap/js/dist/offcanvas';
// import Popover from 'bootstrap/js/dist/popover';
// import ScrollSpy from 'bootstrap/js/dist/scrollspy';
// import Tab from 'bootstrap/js/dist/tab';
// import Toast from 'bootstrap/js/dist/toast';
// import Tooltip from 'bootstrap/js/dist/tooltip';

// App
import { MainMenu } from './modules/global/mainMenu';
import { FrontPage } from './modules/pages/frontPage';

// Keep a single main landmark; demote any unexpected extras added by content.
const enforceSingleMainLandmark = () => {
  const mains = Array.from(document.querySelectorAll('main'));
  if (!mains.length) return;

  mains.forEach((mainEl, index) => {
    if (index === 0) {
      if (!mainEl.getAttribute('role')) {
        mainEl.setAttribute('role', 'main');
      }
      if (!mainEl.hasAttribute('tabindex')) {
        mainEl.setAttribute('tabindex', '-1');
      }
    } else {
      mainEl.setAttribute('role', 'presentation');
      mainEl.removeAttribute('aria-label');
      mainEl.removeAttribute('tabindex');
    }
  });
};

// Ensure image-only links (e.g., figures) expose an accessible name.
const addAccessibleLabelsToFigureLinks = () => {
  const figureLinks = document.querySelectorAll('figure > a');

  figureLinks.forEach((link) => {
    const textContent = link.textContent ? link.textContent.trim() : '';

    if (link.getAttribute('aria-label') || textContent.length > 0) {
      return;
    }

    const img = link.querySelector('img');
    const altText = img && img.getAttribute('alt') ? img.getAttribute('alt').trim() : '';

    if (altText) {
      link.setAttribute('aria-label', altText);
      return;
    }

    if (link.href) {
      try {
        const url = new URL(link.href);
        const hostname = url.hostname.replace(/^www\./, '');
        link.setAttribute('aria-label', `Visit ${hostname}`);
      } catch (error) {
        link.setAttribute('aria-label', 'Visit link');
      }
    }
  });
};

// TripleSeat injects a layout <table> for its lead form after page load. axe /
// AccessibilityChecker treats it as a data table and flags its header row as a
// "caption implemented using a non-caption element." It's a layout table (form
// fields, not tabular data), so mark it presentational to drop the data-table
// semantics. Form controls inside keep their own roles and stay accessible.
const markTripleseatFormTablesPresentational = () => {
  const SELECTOR = 'table[data-cy="tripleseat_embed_form_table"]:not([role])';

  const apply = () => {
    document
      .querySelectorAll(SELECTOR)
      .forEach((table) => table.setAttribute('role', 'presentation'));
  };

  // The form may already be present, or injected later by ts_script.js.
  apply();

  if (!('MutationObserver' in window)) return;

  const observer = new MutationObserver(apply);
  observer.observe(document.body, { childList: true, subtree: true });

  // Stop watching once the form has had time to render.
  window.setTimeout(() => observer.disconnect(), 15000);
};

const initApp = () => {
  const bodyEl = document.getElementsByTagName('body')[0];

  // const Modals = require('./components/global/modals');
  // Modals.init();
  window.showGlobalModal = (selector) => {
    const targetModal = new Modal(selector);
    targetModal.show();
    console.log ( "showGlobalModal" );
  };

  // GLOBAL
  const mainMenu = new MainMenu(Collapse);
  mainMenu.init();
  enforceSingleMainLandmark();
  addAccessibleLabelsToFigureLinks();
  markTripleseatFormTablesPresentational();

  // Popup Maker accessibility fixes
  const PopupAccessibility = require('./components/global/popupAccessibility');
  PopupAccessibility.init();

  // PAGE DETECTION
  if (bodyEl.classList.contains('home')) {
    const frontPage = new FrontPage();
    frontPage.init();
  }
};

(function () {
  document.documentElement.classList.remove('no-js');
  initApp();
})();
